export const EWorkspaceSubscriptionTypeShared = {
  TEAM_FREE: 'TEAM_FREE',
  TEAM_ADVANCED: 'TEAM_ADVANCED',
  TEAM_PRO: 'TEAM_PRO',
};
